import { PYTHON_API_BASE_URL } from "../../../services/api/apiConstants";
import { emailQuery } from "../domain/emailQuery";
import { parseDeleteUserError } from "../domain/deleteUserError";

// A failed user delete. `failure` is FE-25's parsed object
// ({ kind, message, microgrids, count }); `message` is its kind only, so an
// email never reaches a log or an error report through it.
export class DeleteUserFailure extends Error {
  constructor(failure) {
    super(failure.kind);
    this.name = "DeleteUserFailure";
    this.failure = failure;
  }
}

function buildHeaders({ accessToken, userId }) {
  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    "X-User-ID": userId || "",
  };
}

// Sends the DELETE; resolves on a 2xx (its body, which echoes the email, is
// never read) and throws a DeleteUserFailure on anything else.
async function sendDelete(endpoint, { accessToken, userId }) {
  let response;
  try {
    response = await fetch(endpoint, {
      method: "DELETE",
      headers: buildHeaders({ accessToken, userId }),
    });
  } catch {
    throw new DeleteUserFailure(parseDeleteUserError({ networkError: true }));
  }

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new DeleteUserFailure(parseDeleteUserError({ status: response.status, body }));
  }
}

export function deleteCustomer({ accessToken, userId, email }) {
  return sendDelete(`${PYTHON_API_BASE_URL}/customers/delete/?${emailQuery(email)}`, {
    accessToken,
    userId,
  });
}

export function deleteEmployee({ accessToken, userId, email }) {
  return sendDelete(`${PYTHON_API_BASE_URL}/employees/delete/?${emailQuery(email)}`, {
    accessToken,
    userId,
  });
}
